import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/app/src/assets/images/fusha.png");
import(/* webpackMode: "eager" */ "/app/src/assets/images/hero.png");
import(/* webpackMode: "eager" */ "/app/src/assets/images/hero2.png");
import(/* webpackMode: "eager" */ "/app/src/components/EbookPreview.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/FlashcardPreview.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/QuestionBankPreview.tsx")